/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import type { MetadataRoute } from "next";

export const baseRobotsConfig: MetadataRoute.Robots = {
	rules: {
		userAgent: "*",
		disallow: [
			//root no locale paths to disallow
			"/portal*",
			"/register*",
			"/account*",
			"/dashboard*",
			"/id*",
			"/v1/developers*",
			"/internal/*",

			//locale based paths to disallow
			"/*/try-free*",
			"/*/search",

			//disallow urls that have params
			"/*?tags=",
			"/*&tags=",
			"/*?filter=",
			"/*&filter=",
			"/*?lang=",
			"/*&lang=",
			"/*?keyword=",
			"/*&keyword=",
			"/*?skip=",
			"/*&skip=",
		],
	},
	sitemap: `${process.env.EPIC_SERVER_URL}/sitemap.xml`,
};

export function createRobotsConfig(additionalSitemaps: string[] = []): MetadataRoute.Robots {
	const sitemaps = [`${process.env.EPIC_SERVER_URL}/sitemap.xml`, ...additionalSitemaps];

	return {
		...baseRobotsConfig,
		sitemap: sitemaps.length === 1 ? sitemaps[0] : sitemaps,
	};
}

export default function robots(): MetadataRoute.Robots {
	return baseRobotsConfig;
}
